export const logout = {
  texts: {
    mainMessage: 'Ești deautentificat'
  },
  toasts: {
    byeMessage: 'Ne auzim',
    byeTitle: 'Logout',
    byeErrorMessage: 'Nu am reușit de-autentificarea',
    byeErrorTitle: 'Logout'
  }
}
